import { get, put, post } from '@navent-jobs/config'
import { getCookieData } from '../../helpers'
import loggerService from '../logger-service'
import { FiltrosMensajes } from '../../store/mensajes/types'

interface CreateUsuariosProps {
  apellido: string
  email: string
  limitePublicaciones: string
  nombre: string
  password: string
  prefijoTelefono: string
  puesto: string
  tipoUsuario: string
  usuario: string
}

interface EditUsuarioProps {
  passwordActual?: string
  apellido: string
  email: string
  limitePublicaciones: string
  nombre: string
  password: string
  prefijoTelefono: string
  puesto: string
  tipoUsuario: string
  usuario: string
}

interface SignUpResponse {
  empresaId: number
}

class UsuariosService {
  public async signUp(data): Promise<SignUpResponse> {
    const utmOrigen = getCookieData('utm_campaign', document.cookie) || undefined
    return post('api-company/empresas/usuarios/sign-up', { ...data, utmOrigen })
  }

  public getUsuarioMe = () => {
    return get(`api-company/empresas/usuarios/me`)
  }

  public getUsuarios = (page) => {
    const url = 'api-company/empresas/usuarios'
    const params = new URLSearchParams()

    if (page) {
      params.append('page', page.toString())
    }

    const urlRequest = `${url}?${params}`
    return get(urlRequest)
  }

  public deleteUsuarios = (ids) => {
    return post(`api-company/empresas/usuarios/eliminar`, { ids })
  }

  public createUsuarios = (user: CreateUsuariosProps) => {
    return put(`api-company/empresas/usuarios/crear`, user)
  }

  public getDataUsuario = (id: number) => {
    return get(`api-company/empresas/usuarios/usuario/${id}`)
  }

  public editUsuario = (id: number, data: EditUsuarioProps) => {
    return put(`api-company/empresas/usuarios/editar/${id}`, data)
  }

  public validateEmail = (email: string) => {
    return get(`/api-company/empresas/usuarios/cuenta/validate-email/${email}`)
  }

  public validateCuit = async (cuit: string, condicionFiscalId?: number) => {
    try {
      return await get(
        `/api-company/empresas/usuarios/cuenta/validate-cuit/${cuit}?condicionFiscalId=${condicionFiscalId}`
      )
    } catch (error) {
      loggerService.logError(`Fetch CondicionTributariaVerifier Data: ${error.message}`, error.stack)
      return null
    }
  }

  public getEntrgasAvisosUsuario = (id: number) => {
    return get(`api-company/empresas/usuarios/usuario/${id}/entregas-avisos`)
  }

  public getMensajesUsuario = (filters: FiltrosMensajes) => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value))
      }
    })
    const url = `/api-company/empresas/usuarios/mensajes?${params.toString()}`
    return get(url)
  }
}

const usuariosService = new UsuariosService()
export default usuariosService
